module.exports = __webpack_public_path__ + "img/1.210f4ecc.png";